var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import Select from 'syf-component-library/ui/atoms/Select';
import getTranslation from '../../../../strings/i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import getLanguageFromStorage from 'syf-js-utilities/helpers/getLanguageFromStorage';
import formatDisplayDate from 'syf-js-utilities/formats/formatDisplayDate';
import { getFilterAnalyticsProps } from '../../../../const/analytics';
var FilterDateDropdown = function (_a) {
    var excludeAllOption = _a.excludeAllOption, isDisabled = _a.isDisabled, handleChange = _a.handleChange, selectedDate = _a.selectedDate, statements = _a.statements;
    var t = getTranslation().t;
    var allTransactionText = t('activity.allTransactionsFilterOption');
    var recentTransactions = t('activity.recentTransactionsFilterOption');
    var filterByDate = t('activity.byDateFilterOption');
    var currentLang = getLanguageFromStorage();
    var storedLang = useRef(currentLang);
    var _b = useState(false), isSelectExpanded = _b[0], setIsSelectExpanded = _b[1];
    var statementDateOptions = statements.map(function (statement, index) {
        var statementDate = statement.statementDate;
        var date = formatDisplayDate(statementDate);
        var optionValue = t('activity.statementEndingFilterOption', {
            date: "".concat(date)
        });
        return {
            key: "option-".concat(index),
            text: optionValue,
            value: statementDate,
            label: optionValue
        };
    });
    var allOptions = useMemo(function () {
        var defaultOptions = [];
        if (!excludeAllOption) {
            defaultOptions.push({
                key: allTransactionText,
                text: allTransactionText,
                value: 'all',
                label: allTransactionText
            });
        }
        defaultOptions.push({
            key: recentTransactions,
            text: recentTransactions,
            value: 'recent',
            label: recentTransactions
        });
        return statementDateOptions && __spreadArray(__spreadArray([], defaultOptions, true), statementDateOptions, true);
    }, [
        excludeAllOption,
        recentTransactions,
        statementDateOptions,
        allTransactionText
    ]);
    var filterDefaultOptions = allOptions.map(function (obj) {
        return { label: obj.label, value: obj.value };
    });
    var getDefaultOption = function (filterOptions, selectedDateValue) {
        return filterOptions.find(function (_a) {
            var value = _a.value;
            return value === selectedDateValue;
        });
    };
    var analyticsProps = getFilterAnalyticsProps(selectedDate, isSelectExpanded).filter;
    var dataAnalyticsProps = {
        dataObject: analyticsProps['data-object'],
        dataReason: analyticsProps['data-reason'],
        dataType: analyticsProps['data-type']
    };
    var onChange = function (option) {
        if (currentLang === storedLang.current) {
            // Only trigger change if language matches
            handleChange(option.value);
        }
        else {
            // Language has been toggled
            storedLang.current = currentLang;
        }
    };
    useEffect(function () {
        var handleSelect = function () {
            setIsSelectExpanded(true);
        };
        var select = document.getElementById('filter-by-date-combobox') || null;
        select === null || select === void 0 ? void 0 : select.addEventListener('click', handleSelect);
        return function () {
            select === null || select === void 0 ? void 0 : select.removeEventListener('click', handleSelect);
        };
    }, [isSelectExpanded]);
    useEffect(function () {
        setIsSelectExpanded(false);
    }, [handleChange, selectedDate]);
    return (_jsx(Select, __assign({}, dataAnalyticsProps, { isDisabled: isDisabled, "aria-labelledby": "filter-by-date", className: "ensightencustomevent", defaultOption: getDefaultOption(filterDefaultOptions, selectedDate), id: "filter-by-date", name: "filter-by-date", onChange: onChange, options: allOptions, placeholder: filterByDate, rightIconClosed: _jsx(FontAwesomeIcon, { icon: faChevronDown }), rightIconOpen: _jsx(FontAwesomeIcon, { icon: faChevronUp }) })));
};
export default FilterDateDropdown;
//# sourceMappingURL=index.js.map